const proSettings = {
  primaryColor: '#e62828',
  selectedBgColor: '#1890ff',
  pwa: false,
};
export default proSettings;
